import { IApplicationState } from '../../types/redux';

/**
 * Выбирает превью поста
 */
export const selectPostPreview = ({ postPreviewNew }: IApplicationState) => postPreviewNew;
